module.exports = __webpack_public_path__ + "media/images/mailIcon-723d1953.svg";